<template>
    <div class="d-content">
        <!-- Myteam View -->
         <dashboard-content-nav :nav="navItems"/>
        <keep-alive>
            <component :is="currentComponent" :entity_index="entity_index"></component>
        </keep-alive>
    </div>
</template>
<script>
import dashboardContentNav from "@/components/dashboard/contentNav.vue";

//Pages 
import reportees from "./reportees.vue";
import approval from "./approval.vue";
import utility from "./utility.vue";

// this.$router.query
// in query pass the key, paygroup, costcenter
// if 
// currentcomponent(){
  // if costcenter
 // return ()=>import('./coscenter.vue') 
 // elnse if designatio
//
// }
const mapNameToComponents = {
  "reportees": reportees,
  "approval" :approval,
  "utilities" :utility
}

const getPathForStep = (entity_index,step_name, sub_step) => {
  if (sub_step)
    return `/dashboard/${entity_index}/myteam/${step_name}/${sub_step}`
  else
    return `/dashboard/${entity_index}/myteam/${step_name}`
}

const nav_items = (entity_index) =>([
      {
        type: "navitem",
        label: "Reportees",
        path: getPathForStep(entity_index,'reportees'),
        icon : "organisation",
      },
      {
        type: "navitem",
        label: "Approval", 
        path: getPathForStep(entity_index,'approval'),
        icon : "organisation"
      },
      {
        type: "navitem",
        label: "Utilities",
        path: getPathForStep(entity_index,'utilities'),
        icon : "reports"
      }
]);
export default {
   components : {
      dashboardContentNav
  },
  props: ['sub_step','entity_index'],
  data(){
    return{
         navItems : []
    }
  },
   methods:{
    contentShow(event)
    {
      var sections = document.querySelectorAll('.d-payroll__accordBlock');
      for (let i = 0; i < sections.length; i++){
          sections[i].classList.remove('active');
      }
      event.target.parentNode.classList.toggle("active");
    }
  },
  created(){
       this.navItems = nav_items(this.entity_index)
  },
  computed:{
    currentComponent: function() {
        return mapNameToComponents[this.sub_step];
    }
  }
}
</script>
<style>

</style>
